<template>
  <div class="d-flex justify-content-center bg-white overflow-auto">
    <div
      class="d-flex flex-column bg-light w-100"
      style="max-width: 100vw; height: 100vh"
    >
      <div class="container-fluid w-100 p-0">
        <div
          class="p-2 text-center"
          style="background-color: #623a29; width: 100%"
        >
          <marquee
            scrolldelay="85"
            onmouseover="this.stop();"
            onmouseout="this.start();"
          >
            <a
              href="https://bloomprenatalyoga.in/webinar/"
              class="text-white text-decoration-none"
            >
              <i class="fas fa-circle fs-6"></i> WEBINAR ON NUTRITION DURING
              PREGNANCY
            </a>
          </marquee>
        </div>
      </div>
      <div class="container-fluid w-100">
        <div
          class="row text-start p-2"
          style="background-color: #ff7435; font-size: 15px"
        >
          <!-- Mobile & Email (Side by Side) -->
          <div class="col-1">

          </div>
          <div class="col-6  mb-2">
            <a
              href="tel:+919845269938"
              class="text-white text-decoration-none me-3"
            >
              <i class="fas fa-mobile-alt"></i> +91 9845269938
            </a>
            <a
              href="mailto:vaishganu96@gmail.com"
              class="text-white text-decoration-none"
            >
              <i class="far fa-envelope"></i> vaishganu96@gmail.com
            </a>
             <a
              href="https://goo.gl/maps/udiRpj6Pxkai9E4v5"
              class="text-white text-decoration-none"
            >
              <i class="fas fa-star"></i> Google Reviews
            </a>
          </div>
          <div class="col-5 menu text-end">
            <a href="https://www.facebook.com/Bloom-Pre-Natal-and-Therapy-Yoga-106629080744456/" target="_blank">
              <i class="fab fa-facebook"></i>
            </a>
<a href="https://www.instagram.com/bloom.prenatal.yoga/" target="_blank">
              <i class="fab fa-instagram"></i>
            </a>
            <a href="https://www.youtube.com/channel/UCpv1CZNmFsbOV2klFg8Ceiw" target="_blank">
              <i class="fab fa-youtube"></i>
            </a>
             <a href="/#/login">
              <i class="fas fa-sign-in-alt"></i>
            </a>
          </div>
          <!-- Google Reviews (Centered Below) -->
          
        </div>
      </div>
      <section class="container py-4">
        <div class="row align-items-center">
          <div class="col-md-4 text-center">
            <a href="https://bloomprenatalyoga.in/">
              <img
                src="https://bloomprenatalyoga.in/wp-content/uploads/2021/08/Logo-c.png"
                class="img-fluid-logo"
                alt="Bloom Prenatal Yoga Logo"
              />
            </a>
          </div>
          <br />
          <div class="col-md-8">
            <nav class="navbar d-flex justify-content-end navbar-light">
              <!-- Toggle Button -->
              <button
                class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
                id="menuToggle"
              >
                <i class="fas fa-align-justify"></i>
              </button>

              <!-- Collapsible Menu -->
              <div
                class="collapse navbar-collapse justify-content-end card"
                id="navbarNav"
              >
                <ul class="navbar-nav">
                  <li class="nav-item border-bottom">
                    <a class="nav-link" href="#">HOME</a>
                  </li>
                  <li class="nav-item border-bottom">
                    <a class="nav-link" href="#">MEET THE THERAPIST</a>
                  </li>
                  <li class="nav-item border-bottom">
                    <a class="nav-link" href="#">ABOUT PRENATAL YOGA</a>
                  </li>
                  <li class="nav-item border-bottom">
                    <a class="nav-link" href="#">CLASSES</a>
                  </li>
                  <li class="nav-item border-bottom">
                    <a class="nav-link" href="#">OUR CONSULTING PARTNER</a>
                  </li>
                  <li class="nav-item border-bottom">
                    <a class="nav-link" href="#">BLOG</a>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </section>
      <div class="container">
        <div
          class="d-flex align-items-end gap-2 px-3 mb-4 justify-content-lg-center justify-content-md-center overflow-auto flex-nowrap"
        >
          <div class="bg-white flex-shrink-0 flex-nowrap">
            <div
              class="rounded p-2 position-relative cursor-pointer plan"
              data-plan="12"
              style="border: 2px solid #623a29"
            >
              <h4
                class="text-center text-white"
                style="
                  width: 236px;
                  height: 50px;
                  margin: -8px -9px -40px -8px;
                  background-color: #623a29;
                "
              >
                <i class="fas fa-star text-warning fs-6"></i> Best Seller
              </h4>
              <p class="text-dark fw-bold fs-4 mt-5">12 Months</p>
              <div class="d-flex justify-content-between gap-2">
                <p class="text-muted text-decoration-line-through fs-6">
                  INR 12000/-
                </p>
                <p class="fs-6 text-white rounded-lg px-2 py-1 bg-danger">
                  -67% Off
                </p>
              </div>
              <p class="fw-bold text-success fs-2 text-decoration-underline">
                INR 3999
              </p>
              <button
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
                class="btn text-white fs-5 fw-bold w-100 mt-2"
                style="background-color: #ff7345"
              >
                Buy Now
              </button>
            </div>
          </div>
          <div class="bg-white flex-shrink-0" style="width: 15rem">
            <div
              class="border border-secondary rounded p-2 position-relative cursor-pointer plan"
              data-plan="6"
            >
              <p class="text-dark fw-bold fs-5">6 Months</p>
              <div class="d-flex justify-content-between gap-2">
                <p class="text-muted text-decoration-line-through fs-6">
                  INR 6000/-
                </p>
                <p class="fs-6 text-white rounded-lg px-2 py-1 bg-danger">
                  -50% Off
                </p>
              </div>
              <p class="fw-bold text-secondary fs-4">INR 2999</p>
              <button
                class="btn text-white fs-5 fw-bold w-100 mt-2"
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
                style="background-color: #ff7345"
              >
                Buy Now
              </button>
            </div>
          </div>
          <div class="bg-white flex-shrink-0" style="width: 15rem">
            <div
              class="border border-secondary rounded p-2 position-relative cursor-pointer plan"
              data-plan="3"
            >
              <p class="text-dark fw-bold fs-5">3 Months</p>
              <div class="d-flex justify-content-between gap-2">
                <p class="text-muted text-decoration-line-through fs-6">
                  INR 3000/-
                </p>
                <p class="fs-6 text-white rounded-lg px-2 py-1 bg-danger">
                  -34% Off
                </p>
              </div>
              <p class="fw-bold text-secondary fs-4">INR 1999</p>
              <button
                class="btn text-white fs-5 fw-bold w-100 mt-2"
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
                style="background-color: #ff7345"
              >
                Buy Now
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="container pt-4">
        <div class="row col-md-12 col-sm-12">
          <!-- Features Column (Full width on small screens, side column on large screens) -->
          <div class="row ps-2">
            <div class="col-md-4 col-sm-4">
            </div>
            <div class="col-2">
<h4
                  class="fw-bold text-success"
                  style="font-size: 16px; margin-left: -15px; margin-top: -35px"
                >
                  12Months
                </h4>
            </div>
            <div class="col-2">
<h4
                  class="fw-bold text-success"
                  style="font-size: 16px; margin-left: -15px; margin-top: -35px"
                >
                  6 Months
                </h4>
            </div>
            <div class="col-2">
<h4
                  class="fw-bold text-success"
                  style="font-size: 16px; margin-left: -15px; margin-top: -35px"
                >
                  3 Months
                </h4>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 col-sm-4 border-bottom mb-2">
              <h6 style="font-size: 15px">Yoga Everyday</h6>
              <p style="font-size: 10px">with Saurabh Bothra</p>
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
          </div>
 <div class="row">
            <div class="col-md-4 col-sm-4 border-bottom mb-2">
              <h6 style="font-size: 15px">Dance & Strength</h6>
              <p style="font-size: 10px">with Trishala Bothra</p>
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
          </div>
 <div class="row">
            <div class="col-md-4 col-sm-4 border-bottom mb-2">
              <h6 style="font-size: 15px">Flexible Batch Timings</h6>
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
          </div>
 <div class="row">
            <div class="col-md-4 col-sm-4 border-bottom mb-2">
              <h6 style="font-size: 15px">Habit Tracking</h6>
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
          </div>
 <div class="row">
            <div class="col-md-4 col-sm-4 border-bottom mb-2">
              <h6 style="font-size: 15px">Self Healing Marma</h6>
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
            <div class="col-md-2">
              <img src="/app/images/x-payment.png" style="    width: 50px;" class="w-10" />
            </div>
            <div class="col-md-2">
              <img src="/app/images/x-payment.png" style="    width: 50px;" class="w-10" />
            </div>
          </div>
           <div class="row">
            <div class="col-md-4 col-sm-4 border-bottom mb-2">
              <h6 style="font-size: 15px">Hand Mudras</h6>
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
            <div class="col-md-2">
              <img src="/app/images/x-payment.png" style="    width: 50px;" class="w-10" />
            </div>
            <div class="col-md-2">
              <img src="/app/images/x-payment.png" style="    width: 50px;" class="w-10" />
            </div>
          </div>
           <div class="row">
            <div class="col-md-4 col-sm-4 border-bottom mb-2">
              <h6 style="font-size: 15px">Mindful Journaling</h6>
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
            <div class="col-md-2">
              <img src="/app/images/x-payment.png" style="    width: 50px;" class="w-10" />
            </div>
          </div>
           <div class="row">
            <div class="col-md-4 col-sm-4 border-bottom mb-2">
              <h6 style="font-size: 15px">Juice Fast</h6>
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
            <div class="col-md-2">
              <img src="/app/images/x-payment.png" style="    width: 50px;" class="w-10" />
            </div>
          </div>
           <div class="row">
            <div class="col-md-4 col-sm-4 border-bottom mb-2">
              <h6 style="font-size: 15px">Physiotherapy Consultation</h6>
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-sm-4 border-bottom mb-2">
              <h6 style="font-size: 15px">Water Reminders</h6>
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-sm-4 border-bottom mb-2">
              <h6 style="font-size: 15px">Community Sessions</h6>
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
            <div class="col-md-2">
              <img src="/app/images/check-tick.png" class="w-10" />
            </div>
          </div>

        </div>
      </div>
      <footer class="text-white py-3" style="background-color: #62392b">
        <div class="container text-center text-md-start">
          <div class="row align-items-center">
            <div class="row">
              <div class="col-md-3 text-white mt-5">
                <!-- Logo Section -->
                <div class="col-md-4 text-center text-md-start mb-3">
                  <img
                    src="https://bloomprenatalyoga.in/wp-content/uploads/2021/08/logo-1.png"
                    alt="Bloom Logo"
                    style="max-width: 215px"
                  />
                </div>

                <!-- Description Section -->
                <div class="col-md-12 text-center">
                  <p class="mb-3">
                    Founded in Bengaluru, we believe in nurturing a healthy bond
                    between mothers and babies for a joyful 10-month journey.
                  </p>
                </div>

                <!-- Social Icons -->
                <div class="col-md-12 text-center">
                  <a
                    href="https://www.facebook.com/Bloom-Pre-Natal-and-Therapy-Yoga-106629080744456/"
                    target="_blank"
                    class="btn btn-light rounded-circle"
                  >
                    <i class="fab fa-facebook"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/bloom.prenatal.yoga/"
                    target="_blank"
                    class="btn btn-light rounded-circle"
                  >
                    <i class="fab fa-instagram"></i>
                  </a>
                  <a
                    href="https://www.youtube.com/channel/UCpv1CZNmFsbOV2klFg8Ceiw"
                    target="_blank"
                    class="btn btn-light rounded-circle"
                  >
                    <i class="fab fa-youtube"></i>
                  </a>
                </div>
              </div>

              <div class="col-md-3 text-white mt-5 ">
                <h2 class="mb-3">Contact Info</h2>

                <!-- Phone Number -->
                <p>
                  <a
                    href="tel:+919845269938"
                    class="text-white text-decoration-none w-100"
                  >
                    T: +91 98452 69938
                  </a>
                </p>

                <!-- Address -->
                <p>
                  <a
                    href="javascript:void(0)"
                    class="text-white text-decoration-none w-100"
                  >
                    A: D-5 Greenview Apartments
                  </a>
                </p>
                <p>
                  <a
                    href="javascript:void(0)"
                    class="text-white text-decoration-none w-100"
                  >
                    #82, 30th Cross Rd, 4th T Block
                  </a>
                </p>
                <p>
                  <a
                    href="javascript:void(0)"
                    class="text-white text-decoration-none w-100"
                  >
                    East, KV Layout, Jayanagar
                  </a>
                </p>
                <p>
                  <a
                    href="javascript:void(0)"
                    class="text-white text-decoration-none w-100"
                  >
                    Bengaluru, Karnataka 560041
                  </a>
                </p>

                <!-- Email -->
                <p>
                  <a
                    href="mailto:vaishganu96@gmail.com"
                    class="text-white text-decoration-none w-100"
                  >
                    E: vaishganu96@gmail.com
                  </a>
                </p>
              </div>
              <div class="col-md-3  mt-5">
                <h2 class="mb-3">Quick Links</h2>

                <!-- Quick Links Navigation -->

                <p>
                  <a
                    href="https://bloomprenatalyoga.in/about-prenatal-yoga/"
                    class="text-decoration-none text-white"
                    >ABOUT PRENATAL YOGA</a
                  >
                </p>
                <p>
                  <a
                    href="https://bloomprenatalyoga.in/classes/"
                    class="text-decoration-none text-white"
                    >CLASSES</a
                  >
                </p>
                <p>
                  <a
                    href="https://bloomprenatalyoga.in/meet-the-therapist/"
                    class="text-decoration-none text-white"
                    >MEET THE THERAPIST</a
                  >
                </p>
                <p>
                  <a
                    href="https://bloomprenatalyoga.in/blog/"
                    class="text-decoration-none text-white"
                    >BLOG</a
                  >
                </p>
                <p>
                  <a
                    href="https://www.google.com/maps/place/Bloom+Prenatal+and+Therapy+Yoga/@12.9292587,77.5876775,15z/data=!4m5!3m4!1s0x0:0x25861bb09f56c46a!8m2!3d12.9292553!4d77.5876764"
                    class="text-decoration-none text-white"
                    >GOOGLE REVIEWS</a
                  >
                </p>
              </div>
              <div class="col-md-3 text-center  mt-5 mb-3">
                <h2 class="mb-3">Google Maps</h2>
                <div class="ratio ratio-16x9">
                  <iframe
                    loading="lazy"
                    src="https://maps.google.com/maps?q=Bloom%20Prenatal%20and%20Therapy%20Yoga&amp;t=m&amp;z=16&amp;output=embed&amp;iwloc=near"
                    title="Bloom Prenatal and Therapy Yoga"
                    aria-label="Bloom Prenatal and Therapy Yoga"
                  >
                  </iframe>
                </div>
              </div>
            </div>

            <hr />
            <div class="container text-center">
              <span
                >Copyright © 2022
                <strong>Bloom Prenatal and Therapy Yoga</strong> | Designed by
                <a href="#" class="text-white"><strong>FMIM</strong></a>
              </span>
            </div>
          </div>
        </div>
      </footer>
      <!-- Modal -->
      <div
        class="modal fade"
        :class="id ? ['show', 'showPopup'] : []"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true" 
      >
        <div class="modal-dialog modal-fullscreen p-0 m-0">
          <div class="modal-content" style="width: 100vw;">
           <div class="modal-header d-flex align-items-center justify-content-between" style="width: 100%;">
            <!-- Left: Icon + Name -->
            <div class="d-flex align-items-center">
              <i class="fas fa-credit-card text-dark fs-4 me-2"></i>
              <span class="fw-bold">{{ plansList.find(plan => plan.id == id)?.name }} </span>
            </div>
            <!-- Center: Description -->
            <div class="flex-grow-1 text-center">
              <span>Payment Details :{{ plansList.find(plan => plan.id == id)?.description }}</span>
            </div>
            <!-- End: Title + Close Button -->
            <div class="d-flex align-items-center">
              <span class="me-2">{{ plansList.find(plan => plan.id == id)?.title }}</span>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                @click="goToAbout"
              ></button>
            </div>
          </div>
            <div class="modal-body">
              <div style="color:#ff7345">
                <h4>
                  Scan the QR code to pay  &#8377; {{plansList.find(plan => plan.id == id)?.price }}/-  
                </h4>
              </div>
              <img
                src="/app/images/qr-code.png"
                width="400"
                height="400"
                class="ms-4"
              />
              <div>
            <div class="payment-instructions mt-2 " style="margin-left: 300px">
  <h5 class="text-start">Payment Instructions:</h5>
  <div class="instruction-item mb-3 text-start">
    <strong>A.</strong> Please forward the screenshot of the payment proof on 
    <a href="https://wa.me/919845269938" target="_blank" class="text-success text-decoration-none">
      <i class="fab fa-whatsapp"></i> WhatsApp
    </a> 
    to mobile No 
    <a href="tel:+919845269938" class="text-primary text-decoration-none">9845269938</a> 
    with name.
  </div>
  
  <div class="instruction-item mb-3 text-start" >
    <strong>B.</strong> Other payment Options:<br>
    The payment may also be made by way of 
    <span class="text-primary fw-bold">Google Pay</span> or 
    <span class="text-primary fw-bold">Phone Pe</span> 
    to number 
    <a href="tel:+919845269938" class="text-primary text-decoration-none">9845269938</a>, 
    Name <strong>Vaishnavi S</strong>.
  </div>
  
  <div class="instruction-item text-start">
    <strong>C.</strong> In case of any problem in making the payment, please 
    <a href="tel:+919845269938" class="text-primary">
      <i class="fas fa-phone"></i> call
    </a> 
    the above number for clarifications.
  </div>
</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useRoute } from 'vue-router';
import { computed } from 'vue';
export default {
  setup() {
     const route = useRoute();
     const id = computed(() => route.query.id);
       const goToAbout = () => {
      window.location.href = 'https://bloomprenatalyoga.in/about-prenatal-yoga/';
    };
    const plansList =[{
      id:1,
    name:"1 Month Plan",
    price:"4500",
    description: '₹ 4500/ 4 Days/Week',
    title: '16 Classes | Monday to Thursday',
    },
    {
      id:2,
    name:"3 Months Plan - 10% Off",
    price:"12000",
    description: '₹ 12000/ 4 Days/ Week',
    title: '48 Classes | Monday to Thursday',
    },{
      id:3,
    name:"5 Months Plan - 20% Off",
    price:"18000",
    description: '₹ 18000/ 4 Days/ Week',
    title: '80 Classes | Monday to Thursday',
    },
  {
      id:4,
    name:"1 Month Plan",
    price:"3000",
    description: '',
    title: '16 Recorded Videos',
    }, {
      id:5,
    name:"3 Months Plan - 20% Off",
    price:"7500",
    description: '',
    title: '48 Recorded Videos',
    }, {
      id:6,
    name:"5 Months Plan - 35% Off",
    price:"12500",
    description: '',
    title: '80 Recorded Videos',
    }, {
      id:7,
    name:"1 Month Plan",
    price:"4500",
    description: '',
    title: '',
    }, {
      id:8,
    name:"3 Months Plan - 33% Off",
    price:"12000",
    description: '',
    title: '',
    }, {
      id:9,
    name:"6Months Plan - 50% Off",
    price:"18000",
    description: '',
    title: '',
    },
   {
      id:10,
    name:"1 Months Plan",
    price:"3000",
    description: '',
    title: '',
    }]
    return {
      id,
      plansList,
      goToAbout
    };
  },
};
</script>
<style scoped>
.img-fluid-logo {
  width: 10vw;
}
.menu a {
      margin-right: 5px;
      background: black;
    border: 1px solid black;
    border-radius: 50%;
    padding: 5px;
}
.menu a i {
  color: white;
}
.showPopup {
  display: block;padding-left: 0px;
}
</style>